export default "__VITE_ASSET__DhfIFwf0__"